import styled from '@emotion/styled';

export const InfoButtonWrapper = styled.div`
  position: relative;
  width: fit-content;
  height: fit-content;
`;

export const ModalCardContainer = styled.div``;
